import React,{useState} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ListView from './components/progressNotes/ListView';
import FullTextView from './components/progressNotes/FullTextView';
import Assessment from './components/assesments/Assesment';
import ViewReport from './components/ViewReport';
import NoAccess from './components/NoAccess';
import ErrorPage from './components/ErrorPage';
import SamlLoginPage from './components/auth/SamlLoginPage';
import { AuthProvider } from './services/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
// View switcher for ListView/FullTextView

function ProgressNotesViewSwitcher() {
  const [showFullText, setShowFullText] = useState(false);
  return showFullText ? (
    <FullTextView onBackToList={() => setShowFullText(false)} />
  ) : (
    <ListView onShowFullText={() => setShowFullText(true)} />
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Router>
          <Routes>
            {/* SAML Authentication Routes */}
            <Route 
              path="/saml-login" 
              element={<SamlLoginPage />} 
            />
            <Route 
              path="/CCAArchivalUI/ProgressNotes/Index" 
              element={
                <ProtectedRoute>
                  <ProgressNotesViewSwitcher />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/CCAArchivalUI/Assessment/Index" 
              element={
                 <ProtectedRoute>
                  <Assessment />
                </ProtectedRoute>
              } 
            />
            <Route path="/view-report" element={<ViewReport />} />
             <Route path="/no-access" element={<NoAccess />} />
             <Route path="/error" element={<ErrorPage />} />
          </Routes>
        </Router>
      </div>
    </AuthProvider>
  );
}

export default App;
